export enum Feature {
  SSO = 'sso',
  API_INTEGRACION = 'api_integracion',
  DATOS_OPERACIONALES = 'datos_operacionales',
  REDUCCION_EMISIONES = 'reduccion_emisiones'
}
